import { styled } from "@acko-tech/building-blocks.ui.common";

export const Panel = styled.div`
  && button {
    background: #0fa457;
    border-color: #0fa457;
    border-radius: 8px;
    height: 48px;
    box-shadow: 0 -4px 3px rgba(54, 53, 76, 0.08);
  }
  padding: 24px 12px 16px;
  @media (min-width: 768px) {
    padding: 24px 16px;
  }
  text-align: center;
  font-family: "Euclid Circular B", sans-serif;
  h2 {
    margin: 24px 8px 8px;
    white-space: pre-line;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    letter-spacing: -0.1px;
    background: linear-gradient(90deg, #271c7c 2%, #ac28ff 41%, #452f70 81%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }
  p {
    margin: 0 8px 25px;
    @media (min-width: 768px) {
      margin-bottom: 28px;
    }
    color: #36354c;
    opacity: 0.8;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
  }
`;

export const Art = styled.div`
  width: 100px;
  height: 100px;
  margin: auto;
`;

export const Banner = styled.aside`
  position: relative;
  box-sizing: border-box;
  min-height: 110px;
  width: 100%;
  padding: 16px 12px;
  border: 1.3px solid transparent;
  border-radius: 16px;
  background:
    linear-gradient(115deg, #fbe9f6, white 76%) padding-box,
    linear-gradient(135deg, #795dee, #ac52dc, #ff409e) border-box;
  font-family: "Euclid Circular B", sans-serif;
  h2 {
    position: relative;
    margin: 0 0 4px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    background: linear-gradient(90deg, #ec4899, #795dee);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }
  p {
    position: relative;
    margin: 0;
    padding-right: 80px;
    @media (max-width: 767px) {
      padding-right: 60px;
    }
    box-sizing: content-box;
    color: #474649;
    font-size: 12px;
    line-height: 18px;
  }
  img {
    position: absolute;
    right: 15px;
    bottom: 14px;
    @media (max-width: 767px) {
      right: 12.57px;
      bottom: 1.97px;
    }
    width: 61.8065px;
    height: 69.0606px;
  }
`;

export const ClaimsRoot = styled.section`
  width: 100%;
  min-width: 0;
  font-family: "Euclid Circular B", sans-serif;
`;

export const ClaimsTrack = styled.div`
  display: flex;
  gap: 16px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  padding: 2px 1px 4px;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
`;

export const ClaimsCard = styled.article`
  position: relative;
  flex: 0 0 260px;
  box-sizing: border-box;
  height: 96px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 20px;
  overflow: hidden;
  background: white;
  scroll-snap-align: start;
  box-shadow: 0 1px 4px -1px rgba(10, 10, 10, 0.18);
  h2 {
    position: relative;
    margin: 0 0 8px;
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    background: linear-gradient(259.876deg, #f16262 10.347%, #743ddc 106.34%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
  }
  &[data-kind="maruti"] h2 { background-image: linear-gradient(1deg, #1b603d 32%, #44f79b 99%); }
  &[data-kind="paid"] p { width: 144px; }
  p {
    position: relative;
    margin: 0;
    width: 174px;
    color: rgba(0, 0, 0, 0.8);
    font-size: 12px;
    line-height: 18px;
  }
`;

export const Chips = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  span {
    background: #ebf2ff;
    padding: 4px;
    border-radius: 24px;
    font-size: 10px;
    line-height: 14px;
    color: rgba(0, 0, 0, 0.8);
  }
`;

export const Glow = styled.img`
  position: absolute;
  width: 212.239px;
  height: 212.239px;
  left: 114px;
  top: -42px;
  &[data-kind="support"] { left: -86px; top: -97px; }
  &[data-kind="maruti"] { width: 406px; height: 406px; left: 24px; top: -139px; }
`;

export const Illustration = styled.div`
  position: absolute;
  left: 190px;
  top: 14px;
  width: 76px;
  height: 76px;
  overflow: hidden;
  img { position: absolute; width: 216.512px; height: 69.284px; left: -76px; top: 3px; }
  &[data-kind="paid"] {
    left: 196px; top: 16px;
    img { width: 228.54px; height: 73.133px; left: -77.4px; top: 4.87px; transform: scaleX(-1); }
  }
  &[data-kind="maruti"] {
    left: 190px; top: 38px; width: 140px; height: 56.084px; transform: scaleX(-1);
    img { width: 154.22%; height: 256.64%; left: -24.4%; top: -70.18%; }
  }
`;

export const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 0;
  margin-top: 4px;
  button { width: 10px; height: 22px; margin: -8px 0; border: 0; padding: 8px 2px; background: transparent; cursor: pointer; }
  button::after { content: ""; display: block; width: 6px; height: 6px; border-radius: 50%; background: #e7e7f0; }
  button[aria-current="true"]::after { background: #040222; }
`;
